import Node from '../dataset/chord/node.js';

/**
 * function to instatiate node and get attached to manager
 * @param {Object} manager manager API
 */
export default function (manager) {
  const config = manager.config;

  config.nodesOrder.forEach(label => {
    manager.attachChild(Node, 'node', label)
      .configure(config.nodes[label]);
  });
}
